import React, { useEffect } from 'react';

const RainCanvas = () => {
  useEffect(() => {
    const canvas = document.getElementsByClassName('rain')[0];
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const c = canvas.getContext('2d');

    function randomNum(max, min) {
      return Math.floor(Math.random() * max) + min;
    }

    function RainDrops(x, y, endy, velocity, opacity) {
        this.x = x;
        this.y = y;
        this.endy = endy;
        this.velocity = velocity;
        this.opacity = opacity;
    
        this.draw = function() {
            c.beginPath();
            c.moveTo(this.x, this.y);
            c.lineTo(this.x, this.y - this.endy);
            c.lineWidth = 1;
            c.strokeStyle= "rgba(255, 255, 255, " + this.opacity + ")";
            c.stroke();
        }
    
        this.update = function() {
            let rainEnd = window.innerHeight + 100;
            if (this.y >= rainEnd) {
                this.y = this.endy - 100;
            } else {
                this.y = this.y + this.velocity;
            }
            this.draw();
        }
    }

    let rainArray = [];

    for (let i = 0; i < 140; i++) {
        let rainXLocation = Math.floor(Math.random() * window.innerWidth) + 1;
        let rainYLocation = Math.random() * -500;
        let randomRainHeight = randomNum(10, 2);
        let randomSpeed = randomNum(20, .2);
        let randomOpacity = Math.random() * .55;
        rainArray.push(new RainDrops(rainXLocation, rainYLocation, randomRainHeight, randomSpeed, randomOpacity));
    }

    // Animation Loop
    function animate() {
      requestAnimationFrame(animate);
      c.clearRect(0, 0, window.innerWidth, window.innerHeight);
      // Draw and update your raindrops here
      for (let i = 0; i < rainArray.length; i++) {
		rainArray[i].update();
	}
    }

    animate();

    // Clean up the animation when the component unmounts
    return () => cancelAnimationFrame(animate);
  }, []);

  return <canvas className="rain"></canvas>;
};

export default RainCanvas;
